import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { LoadingLegendItem } from "./LoadingLegendItem";
import { LegendItem } from "./LegendItem";
import { LegendLayout } from "./LegendLayout";
import type { ClassificationLegendBreadcrumb } from "./LegendLayout";
import type { ClassificationBreakdownData } from "@components";

export interface ClassificationChartLegendProps {
  breadcrumbs: ClassificationLegendBreadcrumb[];
  chartTitle: string;
  chartTitleTooltipKey?: string;
  items: ClassificationBreakdownData[];
  rootTotalValue: number;
  isLoading?: boolean;
  hoveredItem?: ClassificationBreakdownData | null;
  renderBeforeEl?: (item: ClassificationBreakdownData) => ReactNode;
  onItemHover: (item: ClassificationBreakdownData | null) => void;
  onItemClick: (item: ClassificationBreakdownData) => void;
  onInvestmentClick?: (item: ClassificationBreakdownData) => void;
}

export const ClassificationChartLegend = ({
  breadcrumbs,
  chartTitle,
  chartTitleTooltipKey,
  items,
  rootTotalValue,
  isLoading = false,
  hoveredItem,
  renderBeforeEl,
  onItemHover,
  onItemClick,
  onInvestmentClick,
}: ClassificationChartLegendProps) => {
  return (
    <Box p={0}>
      <LegendLayout
        breadcrumbs={breadcrumbs}
        chartTitle={chartTitle}
        chartTitleTooltipKey={chartTitleTooltipKey}
      >
        {isLoading
          ? Array.from({ length: 5 }).map((_, index) => (
              <LoadingLegendItem index={index} key={`loading-${index}`} />
            ))
          : items.map((item, index) => (
              <LegendItem
                key={item.uid}
                item={item}
                rootTotalValue={rootTotalValue}
                isSelected={hoveredItem?.uid === item.uid}
                beforeEl={renderBeforeEl?.(item)}
                isLast={index === items.length - 1}
                onMouseEnter={() => onItemHover(item)}
                onMouseLeave={() => onItemHover(null)}
                onClick={
                  item.hasChildren
                    ? () => onItemClick(item)
                    : onInvestmentClick
                      ? () => onInvestmentClick(item)
                      : undefined
                }
              />
            ))}
      </LegendLayout>
    </Box>
  );
};
